export class CrearCuentaValidaSmsPeticion {
    codCliente: string;
    codTpoPortal: string;
    docEmpresa: string;

    claveSms: string;
    movilUsuario: string;
}